import { userConstants } from "../../constant";

export function sellerVerification(state = null, action) {
  switch (action.type) {
    case userConstants.GET_SELLER_VERIFICATION:
      return action.payload;
    case userConstants.SUBMIT_SELLER_VERIFICATION:
      return action.payload;
    default:
      return state;
  }
}
